import { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { NAVIGATION_STYLES } from 'store/config/displayOptions.config';
import { selectNavigationStyle } from 'store/selectors/DisplayOptions/displayOptionsSelectors';
import AccountForm from './components/AccountForm/AccountForm';
import ChangePassword from './features/ChangePassword/index.web';
import useAccountProfile from './hooks/useAccountProfile';

/** Compose account editing and password changes using the selected navigation appearance. */
const Account = () => {
  const navigationStyle = useSelector(selectNavigationStyle);
  const isClassic = navigationStyle === NAVIGATION_STYLES.CLASSIC;
  const [showChangePassword, setShowChangePassword] = useState(false);
  const { profile, canEdit, canSave, isLoading, error, message, changeProfile, saveProfile } =
    useAccountProfile();

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <Spinner animation="border" role="status" aria-label="Loading account information" />
      </div>
    );
  }

  if (showChangePassword) {
    return <ChangePassword isClassic={isClassic} onBack={() => setShowChangePassword(false)} />;
  }

  return (
    <AccountForm
      isClassic={isClassic}
      profile={profile}
      canEdit={canEdit}
      canSave={canSave}
      error={error}
      message={message}
      onChange={changeProfile}
      onSave={saveProfile}
      onChangePassword={() => setShowChangePassword(true)}
    />
  );
};

export default Account;
